// @flow

import React from 'react'
import FooterBottom from 'components/shared/footer/FooterBottom'
import FooterExternal from 'components/shared/footer/FooterExternal'

type PropTypes = {
  hasFooter?: boolean,
}

export default function Footer(props: PropTypes) {
  if (!props.hasFooter) {
    return null
  }

  return (
    <footer>
      <FooterExternal />
      <FooterBottom />
    </footer>
  )
}

Footer.defaultProps = {
  hasFooter: true,
}



// WEBPACK FOOTER //
// ./src/components/shared/footer/Footer.jsx